import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const criticalNoCallValidationSchema = () => {
  return createValidationSchema({
    isCallIndicated: commonValidationSchemas
      .string({
        nullable: false,
        required: true,
      })
      .oneOf(['true', 'false']),
    whyNotIndicated: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        when: {
          fields: ['isCallIndicated'],
          is: (isCallIndicated) => isCallIndicated === 'false',
          then: { required: true, min: 1 },
        },
      },
    ),
    whyNotIndicatedText: commonValidationSchemas.string({
      when: {
        fields: ['whyNotIndicated'],
        is: (whyNotIndicated) => whyNotIndicated.includes('Other'),
        then: { required: true, min: 1 },
      },
    }),
    whoAttemptedCall: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        when: {
          fields: ['isCallIndicated'],
          is: (isCallIndicated) => isCallIndicated === 'true',
          then: { required: true, min: 1 },
        },
      },
    ),
    isReadingEscalated: commonValidationSchemas
      .string({
        nullable: true,
        required: true,
      })
      .oneOf(['true', 'false']),

    escalatedVia: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        when: {
          fields: ['isReadingEscalated'],
          is: (isReadingEscalated) => isReadingEscalated === 'true',
          then: { required: true, min: 1 },
        },
      },
    ),
    escalatedReasons: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        when: {
          fields: ['isReadingEscalated'],
          is: (isReadingEscalated) => isReadingEscalated === 'true',
          then: { required: true, min: 1 },
        },
      },
    ),
    notEscalatedReasons: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      {
        when: {
          fields: ['isReadingEscalated'],
          is: (isReadingEscalated) => isReadingEscalated === 'false',
          then: { required: true, min: 1 },
        },
      },
    ),
    notEscalatedReasonsOther: commonValidationSchemas.string({
      when: {
        fields: ['notEscalatedReasons'],
        is: (notEscalatedReasons) => notEscalatedReasons.includes('Other'),
        then: { required: true, min: 1 },
      },
    }),
  });
};
